import React, { Component } from "react";
import { connect } from 'react-redux';
import * as wActs from '../actions/website-actions'
import SwBanner from "./swbanner";

class RightBanners extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }



  render() {
    return (
      <div className={"flex-center"}>
        <p style={{borderBottom: "solid 1px #ccc", color: "#ccc", width: "100%", textAlign: "left", marginBottom: "5px", maxWidth: "300px"}}><i className="fa fa-newspaper"></i>&nbsp;{this.getTranslation("page.advertise.ournetwork")}</p>
        <div className="four-center-banner">
          <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId}  id={"our-network-300x100"} channel={wActs.SubDomain(this.props.WebPage)} count={"20"} maxStandard={20} minBuyAds={"0"} maxBuyAds={"0"} className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}>
          </SwBanner>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections
  };
}

export default connect(mapStateToProps)(RightBanners);
